export interface AppPlatform {
  id: number;
  type: AppPlatformTypeEnum;
  name: AppPlatformNameEnum;
  display_name: string;
}

interface AppDomain {
  id: number;
  value: string;
}

export enum AppPlatformNameEnum {
  Web = 'widget_web',
  Android = 'widget_mobilesdk_android',
  iOS = 'widget_mobilesdk_ios',
}

export enum AppPlatformTypeEnum {
  Web = 'web',
  Mobile = 'mobilesdk',
}

export class UserAppModel {
  // app
  id: number;
  app_name: string;
  app_description: string;

  // app keys
  app_apikey: string;
  app_apisecret: string;

  // platforms
  app_platform: AppPlatform[];

  // domains
  app_domains: AppDomain[];
  developer_appdomain_limit: number;

  // developer
  developer_id: number;
  developer_email: string;
  developer_first_name: string;
  developer_last_name: string;

  // time
  registration_datetime: string;
  timestamp: string;
}
